import { actionTypes } from 'redux-firestore';

const { GET_FAILURE, GET_REQUEST, GET_SUCCESS } = actionTypes;

const initialState = {
  hasFailed: false,
  isRequesting: false,
  isSuccessful: false,
};

const get = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUEST:
      return {
        hasFailed: false,
        isRequesting: true,
        isSuccessful: false,
      };
    case GET_SUCCESS:
      return {
        hasFailed: false,
        isRequesting: false,
        isSuccessful: true,
      };
    case GET_FAILURE:
      return {
        hasFailed: true,
        isRequesting: false,
        isSuccessful: false,
      };
    default:
      return state;
  }
};

export default get;



// WEBPACK FOOTER //
// ./src/redux/reducers/get.js